import { NgxSpinnerService } from 'ngx-spinner';
import { ProcessControl } from './../../models/processcontrol/processControl';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProcessControlService } from 'src/app/services/process-control.service';
import { WebSocketService } from 'src/app/services/web-socket.service';
import { RoleService } from 'src/app/services/role.service';
import { StorageUtil } from 'src/app/utils/storage.util';
import { MessageUtil } from 'src/app/utils/message.util';
import { HttpClient } from '@angular/common/http';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { ResultDialogComponent } from 'src/app/pages/billing/billets-management/outfile/result-dialog/result-dialog.component';
import { ResultDialogInvoiceComponent } from './result-dialog-invoice/result-dialog-invoice.component';
import { EnotasNfeGenerateResultDialogComponent } from './enotas-nfe-generate-result-dialog/enotas-nfe-generate-result-dialog.component';
import { ProcessControlType } from 'src/app/models/enums/process-control-type.enum';

@Component({
  selector: 'app-process-control-form',
  templateUrl: './process-control-form.component.html',
  styleUrls: ['./process-control-form.component.scss'],
})
export class ProcessControlFormComponent implements OnInit {
  listaProcessos: ProcessControl[] = [];

  private processSubscription: Subscription;

  isDeveloper = false;

  constructor(
    private processControlService: ProcessControlService,
    private spinner: NgxSpinnerService,
    private webSocketService: WebSocketService,
    private roleService: RoleService,
    public messageUtil: MessageUtil,
    private http: HttpClient,
    private dialog: DialogService
  ) {}

  ngOnInit() {
    this.getProcessos();
    this.checkIfUserIsDeveloper();
    this.processSubscription = this.webSocketService
      .getProcessControl()
      .subscribe(async (message) => {
        this.spinner.show();
        this.getProcessos();
        this.spinner.hide();
      });
  }

  private convertUTCToLocalDate(date: Date | string): Date {
    if (!date) return null;
    const utcDate = new Date(date);
    return new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60000));
  }

  getProcessos() {
    this.processControlService.getAll().subscribe({
      next: (resp) => {
        this.listaProcessos = resp.map(process => ({
          ...process,
          startDate: this.convertUTCToLocalDate(process.startDate),
          endDate: this.convertUTCToLocalDate(process.endDate)
        }));
      },
      error: (error) => {
        // Swal.fire('Atenção', 'Erro ao Recuperar imformações', 'warning');
      },
    });
  }

  download(file: string, process: ProcessControl) {
    if (!file) {
      return;
    }
    const description = process?.description;
    const type = process?.type as ProcessControlType | string | undefined;

    if (type === ProcessControlType.ENOTAS_NFE_GENERATE && file.toLowerCase().endsWith('.json')) {
      this.http
        .get(file, {
          responseType: 'text',
          headers: { Accept: 'application/json, text/plain, */*' },
        })
        .subscribe({
          next: (response: string) => {
            try {
              const data = JSON.parse(response);
              this.dialog.open(EnotasNfeGenerateResultDialogComponent, {
                width: '80%',
                height: '85%',
                dismissableMask: false,
                data,
                header: this.messageUtil.translateKey('ENOTAS-NFE-GENERATE-DETAIL-TITLE'),
              });
            } catch (parseError) {
              console.error('Erro ao fazer parse do JSON eNotas NF:', parseError);
              window.open(`${file}`, '_blank').focus();
            }
          },
          error: () => window.open(`${file}`, '_blank').focus(),
        });
      return;
    }

    if (description === 'Importação arquivo de Retorno.' || description === 'Geração de Fatura.') {
      this.http
        .get(file, {
          responseType: 'text',
          headers: { Accept: 'application/json, text/plain, */*' },
        })
        .subscribe({
          next: (response: string) => {
            try {
              const data = JSON.parse(response);
              if (description === 'Geração de Fatura.') {
                this.dialog.open(ResultDialogInvoiceComponent, {
                  width: '75%',
                  height: '80%',
                  dismissableMask: false,
                  data,
                  header: 'Detalhes da Geração de Fatura',
                });
              } else {
                this.dialog.open(ResultDialogComponent, {
                  width: '75%',
                  height: '80%',
                  dismissableMask: false,
                  data,
                  header: 'Resultado de importação do banco ',
                });
              }
            } catch (parseError) {
              console.error('Erro ao fazer parse do JSON:', parseError);
              window.open(`${file}`, '_blank').focus();
            }
          },
          error: () => window.open(`${file}`, '_blank').focus(),
        });
      return;
    }
    window.open(`${file}`, '_blank').focus();
  }

  downloadLog(process: ProcessControl) {
    const jsonUrl = process?.urlFile1;
    if (process?.description === 'Importação arquivo de Retorno.' && jsonUrl) {
      const url = jsonUrl.replace(/\.json$/, '.txt');
      window.open(`${url}`, '_blank').focus();
      return;
    }
    if (process?.type === ProcessControlType.ENOTAS_NFE_GENERATE && process.urlFile2) {
      window.open(`${process.urlFile2}`, '_blank').focus();
      return;
    }
    if (jsonUrl) {
      window.open(`${jsonUrl}`, '_blank').focus();
    }
  }

  showReturnImportLogShortcut(process: ProcessControl): boolean {
    return process?.description === 'Importação arquivo de Retorno.';
  }

  isLogFile(fileUrl: string): boolean {
    if (!fileUrl) {
      return false;
    }
    return (
      fileUrl.endsWith('logBoletos.txt') ||
      fileUrl.endsWith('logInvoice.txt') ||
      fileUrl.endsWith('logNfeEnotas.txt')
    );
  }

  shouldDisplayFile(fileUrl: string): boolean {
    if (!fileUrl) {
      return false;
    }
    if (this.isLogFile(fileUrl)) {
      return this.isDeveloper;
    }
    return true;
  }

  checkIfUserIsDeveloper() {
    const userId = StorageUtil.getUserId();
    this.roleService.isDeveloper(userId).subscribe({
      next: (isDeveloper) => {
        this.isDeveloper = isDeveloper;
      },
      error: (error) => {
        console.error('Erro ao verificar se o usuário é desenvolvedor:', error);
        this.isDeveloper = false;
      }
    });
  }
}
